
























































































































































import {
  defineComponent, reactive, ref, useContext, useRouter,
} from '@nuxtjs/composition-api';
import { SfIcon, SfModal } from '@storefront-ui/vue';
import { getExpertAdviceLink } from '~/cms/helpers/urls';
import BKButton from '~/components/BK/BKButton.vue';
import AnswerOption from '~/components/BikeFinder/AnswerOption.vue';
import { Option, Question, getQuestions } from '~/components/BikeFinder/questions';
import { useUiState } from '~/composables/useUiState';
import { useBikeFinderStore } from '~/modules/catalog/category/stores/bikefinder';
import { Routes } from '../../helpers/routes';

export default defineComponent({
  name: 'BikeFinder',
  components: {
    SfModal,
    BKButton,
    AnswerOption,
    SfIcon,
  },
  setup() {
    const {
      motorSupportQuestion, getCategoryQuestion, questionsByCategories, getDependencyQuestions,
    } = getQuestions();
    const { isBikeFinderModalOpen, toggleBikeFinderModal } = useUiState();
    const router = useRouter();

    const selectedAnswers = ref<{
      [key: string]: any;
    }>({});
    const selectedAnswersOptions = ref<{
      question: Question;
      option: Option;
    }[]>([]);
    const currentQuestion = ref<Question>();
    const categorySpecificQuestions = ref<Question[]>();
    const { localePath } = useContext();
    const isSummaryScreen = ref(false);
    const redirectUrl = ref('');

    function selectOption(option: Option): void {
      // Logic to save chosen options, so we can display them at the summary screen
      if (selectedAnswersOptions.value.length > 0) {
        if (currentQuestion.value.singleSelection) {
          // eslint-disable-next-line max-len
          const sameQuestionOption = selectedAnswersOptions.value.find((selectedAnswersOption: { question: Question; option: Option; }) => selectedAnswersOption.question.id === currentQuestion.value.id);

          if (sameQuestionOption) {
            // eslint-disable-next-line max-len
            selectedAnswersOptions.value.splice(selectedAnswersOptions.value.indexOf(sameQuestionOption), 1, { question: currentQuestion.value, option });
          } else {
            selectedAnswersOptions.value.push({ question: currentQuestion.value, option });
          }
        } else {
          // eslint-disable-next-line max-len
          const sameOption = selectedAnswersOptions.value.find((selectedAnswersOption: { question: Question; option: Option; }) => selectedAnswersOption.option === option);

          if (sameOption) {
            // eslint-disable-next-line max-len
            selectedAnswersOptions.value.splice(selectedAnswersOptions.value.indexOf(sameOption), 1);
          } else {
            selectedAnswersOptions.value.push({ question: currentQuestion.value, option });
          }
        }
      } else {
        selectedAnswersOptions.value.push({ question: currentQuestion.value, option });
      }

      if (currentQuestion.value.singleSelection) {
        selectedAnswers.value[currentQuestion?.value.paramName] = option.value;
      } else {
        if (!selectedAnswers.value[currentQuestion?.value.paramName]) {
          selectedAnswers.value[currentQuestion?.value.paramName] = [];
        }

        if (typeof option.value === 'object') {
          if (!option.value.every((val) => selectedAnswers.value[currentQuestion?.value.paramName].includes(val))) {
            // add it
            selectedAnswers.value[currentQuestion?.value.paramName] = [...selectedAnswers.value[currentQuestion?.value.paramName], ...option.value];
          } else {
            // remove it
            selectedAnswers.value[currentQuestion?.value.paramName] = selectedAnswers.value[currentQuestion?.value.paramName].filter(
              // eslint-disable-next-line
              (data) => !(option.value as number[]).includes(data)
            );

            if (selectedAnswers.value[currentQuestion?.value.paramName].length === 0) {
              delete selectedAnswers.value[currentQuestion?.value.paramName];
            }
          }
        } else if (!selectedAnswers.value[currentQuestion?.value.paramName].includes(option.value)) {
          // add it
          selectedAnswers.value[currentQuestion?.value.paramName].push(option.value);
        } else {
          // remove it
          selectedAnswers.value[currentQuestion?.value.paramName].splice(
            selectedAnswers.value[currentQuestion?.value.paramName].indexOf(option.value),
            1,
          );

          if (!selectedAnswers.value[currentQuestion?.value.paramName]?.length) {
            delete selectedAnswers.value[currentQuestion?.value.paramName];
          }
        }
      }

      selectedAnswers.value = {
        ...selectedAnswers.value,
      };
    }

    function onBackClick(): void {
      if (isSummaryScreen.value) {
        isSummaryScreen.value = false;
        return;
      }

      // Remove options selected from the previous screen
      if (selectedAnswersOptions.value.length > 0) {
        // eslint-disable-next-line max-len
        selectedAnswersOptions.value = selectedAnswersOptions.value.filter((selectedAnswersOption) => selectedAnswersOption.question.id !== currentQuestion.value.id);
      }

      if (selectedAnswers.value[currentQuestion?.value.paramName] !== undefined) {
        delete selectedAnswers.value[currentQuestion?.value.paramName];
      }
      if (currentQuestion.value.id === 1) {
        currentQuestion.value = undefined;
      } else if (currentQuestion.value.id === 2) {
        currentQuestion.value = motorSupportQuestion;
      } else {
        const index = categorySpecificQuestions.value.indexOf(currentQuestion.value);
        if (index > 0) {
          currentQuestion.value = categorySpecificQuestions.value[index - 1];
        } else if (index === 0) {
          currentQuestion.value = getCategoryQuestion(selectedAnswers.value[motorSupportQuestion.paramName] === 'e-bikes');
        }

        if (currentQuestion.value.dependencyParamName) {
          const dependencyQuestions = getDependencyQuestions(
            currentQuestion.value.dependencyParamName,
            selectedAnswers.value[currentQuestion.value.dependencyParamName] as string,
            selectedAnswers.value['hardtail-or-fully'] !== undefined,
            selectedAnswers.value.bikeType === 'e-bikes',
          );
          categorySpecificQuestions.value = categorySpecificQuestions.value.filter((item: Question) => !dependencyQuestions.includes(item));
        }
      }
    }

    function prepareFilters(): void {
      let { bikeType } = selectedAnswers.value;
      let { category } = selectedAnswers.value;
      const { onRoadSubcategory } = selectedAnswers.value;
      let hardtailOrFully = selectedAnswers.value['hardtail-or-fully'];
      const onOffRoad = selectedAnswers.value['on-off-road'];
      const weightOrRange = selectedAnswers.value['weight-or-range'];

      isSummaryScreen.value = true;

      if (onOffRoad) {
        if (bikeType === 'e-bikes') {
          if (onOffRoad === 'off') {
            category = 'e-crossbikes';
          } else if (onOffRoad === 'on') {
            if (weightOrRange === 'weight') {
              bikeType = 'light-e-bikes';
              category = 'light-e-trekkingbikes';
            } else if (weightOrRange === 'range') {
              category = 'e-trekkingbikes';
            }
          }
        } else if (bikeType === 'fahrrader') {
          if (onOffRoad === 'on') {
            category = onRoadSubcategory;
          } else if (onOffRoad === 'off') {
            category = 'crossbikes';
          }
        }
      } else if (weightOrRange) {
        if (weightOrRange === 'weight') {
          bikeType = 'light-e-bikes';
          category = 'light-e-mountainbikes';
        } else if (weightOrRange === 'range') {
          category = 'e-mountainbikes';
        }
      }

      if (category === 'light-e-gravelbikes') {
        bikeType = 'light-e-bikes';
      }

      if (bikeType === 'light-e-bikes') {
        // light e bikes don't have hardtail or fully category
        hardtailOrFully = undefined;
      }

      redirectUrl.value = `${localePath(`/${Routes.CATEGORY}/alle-rader`)}/${[bikeType, category, hardtailOrFully].filter((item) => item !== undefined).join('/')}`;

      Object.keys(selectedAnswers.value).forEach((key, index) => {
        if (!index) {
          redirectUrl.value += '?';
        }
        if (!['bikeType', 'category', 'hardtail-or-fully', 'on-off-road', 'weight-or-range', 'onRoadSubcategory'].includes(key)) {
          // key is not a category deciding property, so it needs to be added as URl query parameter
          if (key === 'price') {
            // Example: "price":["10000_100000","0_2200"]
            let min: number;
            let max: number;
            selectedAnswers.value[key].forEach((price: string) => {
              const splittedPrice = price.split('-');
              const lowerLimit = splittedPrice[0];
              const upperLimit = splittedPrice[1];

              if (min === undefined) {
                min = +lowerLimit;
                max = +upperLimit;
              } else {
                if (+lowerLimit < min) {
                  min = +lowerLimit;
                }
                if (+upperLimit > max) {
                  max = +upperLimit;
                }
              }
            });

            if (min !== undefined && max !== undefined) {
              redirectUrl.value += `${index > 0 ? '&' : ''}${key}=${min}_${Math.floor(max * 1.1)}`;
            }
          } else if (typeof selectedAnswers.value[key] === 'object') {
            selectedAnswers.value[key].forEach((answer) => {
              redirectUrl.value += `${index > 0 ? '&' : ''}${key}=${answer}`;
            });
          } else {
            redirectUrl.value += `${index > 0 ? '&' : ''}${key}=${selectedAnswers.value[key]}`;
          }
        }
      });
    }

    function onContinueClick(isLastQuestion: boolean = false): void {
      if (isLastQuestion) {
        isSummaryScreen.value = true;
        prepareFilters();
        return;
      }
      if (currentQuestion.value.id === 1) {
        currentQuestion.value = getCategoryQuestion(selectedAnswers.value[currentQuestion?.value.paramName] === 'e-bikes');
      } else if (currentQuestion.value.id === 2) {
        categorySpecificQuestions.value = questionsByCategories[selectedAnswers.value[currentQuestion?.value.paramName]];
        // eslint-disable-next-line
        currentQuestion.value = categorySpecificQuestions.value[0];
      } else {
        if (currentQuestion.value.dependencyParamName) {
          categorySpecificQuestions.value = [
            ...categorySpecificQuestions.value,
            ...getDependencyQuestions(
              currentQuestion.value.dependencyParamName,
              selectedAnswers.value[currentQuestion.value.dependencyParamName] as string,
              selectedAnswers.value['hardtail-or-fully'] !== undefined,
              selectedAnswers.value.bikeType === 'e-bikes',
            ),
          ];
        }
        const index = categorySpecificQuestions.value.indexOf(currentQuestion.value);
        if (index >= 0 && index < categorySpecificQuestions.value.length - 1) {
          currentQuestion.value = categorySpecificQuestions.value[index + 1];
        }
      }
    }

    function showResults(): void {
      if (redirectUrl.value) {
        router.push(redirectUrl.value);
      } else {
        throw new Error('No Redirect URl was generated');
      }
      toggleBikeFinderModal();
    }

    const isAnswerSelected = reactive((answerValue: string | boolean | number | number[]): boolean => {
      if (currentQuestion.value.singleSelection) {
        return selectedAnswers.value[currentQuestion?.value.paramName] === answerValue;
      }
      if (typeof answerValue === 'object') {
        return answerValue.every((val) => selectedAnswers.value[currentQuestion?.value.paramName]?.includes(val));
      }
      if (selectedAnswers.value[currentQuestion?.value.paramName]?.includes(answerValue)) {
        return true;
      }

      return false;
    });

    function redirectToExpertPage() : void {
      toggleBikeFinderModal();

      const bikeFinderStore = useBikeFinderStore();
      bikeFinderStore.$patch((state) => {
        state.bikefinderUrl = redirectUrl.value;
      });

      router.push(getExpertAdviceLink().url);
    }

    return {
      isBikeFinderModalOpen,
      currentQuestion,
      motorSupportQuestion,
      selectOption,
      onBackClick,
      onContinueClick,
      selectedAnswers,
      selectedAnswersOptions,
      isAnswerSelected,
      prepareFilters,
      showResults,
      isSummaryScreen,
      redirectToExpertPage,
      toggleBikeFinderModal,
    };
  },
});
